const initialState = () => ({
  conversionErrors: {},
});

export default {
  state: initialState(),
  actions: {
    // Consumer -> Agent. payload: { user_id, organization_id, location_id, user_role }
    async convertUserToAgent({ commit }, payload = {}) {
      let res = await this._vm.$api.post("UserConvertToAgent", { _notify: true, ...payload });
      commit("setConversionErrors", res && "errors" in res.data ? res.data.errors : {});
      return res && (res.status === 200 || res.status === 201);
    },

    // Agent -> Consumer. payload: { user_id }
    async convertUserToConsumer({ commit }, payload = {}) {
      let res = await this._vm.$api.post("UserConvertToConsumer", { _notify: true, ...payload });
      commit("setConversionErrors", res && "errors" in res.data ? res.data.errors : {});
      return res && (res.status === 200 || res.status === 201);
    },
  },
  mutations: {
    setConversionErrors(state, data) {
      state.conversionErrors = data;
    },
    ResetUserSwitch(state) {
      const newState = initialState();
      Object.keys(newState).forEach((key) => {
        state[key] = newState[key];
      });
    },
  },
  getters: {
    getConversionErrors: (state) => state.conversionErrors,
  },
};
